import {
	IonButton,
	IonButtons,
	IonCol,
	IonContent,
	IonFooter,
	IonGrid,
	IonHeader,
	IonInput,
	IonItem,
	IonLabel,
	IonList,
	IonListHeader,
	IonModal,
	IonRadio,
	IonRadioGroup,
	IonRow,
	IonSelect,
	IonSelectOption,
	IonTitle,
	IonToolbar,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { addUser } from "../../../services/users";

interface props {
	modalOpen: any;
	setModalOpen: any;
	usersData: any;
}

const AddUserModal: React.FC<props> = ({
	modalOpen,
	setModalOpen,
	usersData,
}) => {
	const defaultValue = {
		displayName: "",
		email: "",
		username: "",
		lead: "",
		study: "",
		role: "participant",
	};

	const [user, setUser] = useState<any>(defaultValue);
	const [users, setUsers] = useState<any>({});
	const [admins, setAdmins] = useState<any>({});
	const [study, setStudy] = useState<any>("sleep");
	const [lead, setLead] = useState<any>("");
	const [error, setError] = useState<any>("");

	const { displayName, email, username, password, role } = user;

	useEffect(() => {
		if (usersData) {
			setUsers(usersData);
			let adminUsers = Object.values(usersData).filter(
				(user: any) => user.isAdmin
			);
			setAdmins(adminUsers);
		}
	}, [usersData]);

	const _checkUsername = (username: any) => {
		let res = true;

		users.forEach((user: any) => {
			if (user.username === username) {
				res = false;
			}
		});

		// if (username === "DJB") {
		// 	console.log("triggered");
		// 	res = false;
		// }

		return res;
	};

	const _generateUsername = (initials: any) => {
		//initials = initials.toUpperCase();
		//const checkedName = _checkUsername(username);
		let username = initials;
		let i = 1;
		while (!_checkUsername(username)) {
			username = initials + i;
			i++;
		}
		return username;
	};

	const _onChange = (e: any) => {
		let field = e.target.name;
		let value = e.target.value;

		if (field === "displayName" && role === "participant") {
			let initials = value.toUpperCase();
			let username = _generateUsername(initials);
			setUser({ ...user, displayName: initials, username: username });
		} else setUser({ ...user, [field]: value });
	};

	const _generatePassword = () => {
		var pwdChars =
			"0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz@!#$%^&*";
		var pwdLen = 10;
		var randPassword = Array(pwdLen)
			.fill(pwdChars)
			.map(function (x) {
				return x[Math.floor(Math.random() * x.length)];
			})
			.join("");

		setUser({ ...user, password: randPassword });
	};

	const _onDissmissModal = () => {
		//console.log("dismissed. we need to do something here.");
		setUser(defaultValue);
		setModalOpen(false);
	};

	const _addUser = () => {
		if (displayName === "") {
			setError("Display name");
		}
		//console.log("add user");
		let userData = { displayName, lead, study, username, role };
		if (role === "admin") {
			userData = { displayName, lead: "", study: "", username: email, role };
			addUser(userData, { email, password });
		} else addUser(userData, { username, password });

		_onDissmissModal();
	};

	const _compareStudy = (o1: any, o2: any) => {
		return o1 === study;
	};

	const _compareLead = (o1: any, o2: any) => {
		return o1 === lead;
	};

	const _onSelect = (e: any) => {
		if (e.target.name === "study") setStudy(e.target.value);
		else if (e.target.name === "lead") setLead(e.target.value);
	};

	const _onRadio = (option: any, value: any) => {
		setUser({ ...user, [option]: value });
	};

	return (
		<IonModal
			isOpen={modalOpen}
			onDidDismiss={_onDissmissModal}
			cssClass="my-custom-class"
		>
			<IonHeader translucent>
				<IonToolbar>
					<IonTitle>Modal Content</IonTitle>
					<IonButtons slot="end">
						<IonButton onClick={_onDissmissModal}>Close</IonButton>
					</IonButtons>
				</IonToolbar>
			</IonHeader>
			<IonContent>
				<p>This is modal content. Yeehaa!!!</p>
				<IonList>
					<IonItem>
						<IonList>
							<IonRadioGroup
								value={role}
								onChange={_onChange}
								id="role"
								name="role"
							>
								<IonListHeader>
									<IonLabel>User Role</IonLabel>
								</IonListHeader>

								<IonItem>
									<IonLabel>Participant</IonLabel>
									<IonRadio
										slot="start"
										value="participant"
										onClick={() => _onRadio("role", "participant")}
									/>
								</IonItem>
								<IonItem>
									<IonLabel>Admin</IonLabel>
									<IonRadio
										slot="start"
										value="admin"
										onClick={() => _onRadio("role", "admin")}
									/>
								</IonItem>
							</IonRadioGroup>
						</IonList>
					</IonItem>
					{role === "admin" && (
						<>
							<IonItem>
								<IonLabel position="floating">Display Name</IonLabel>
								<IonInput
									name="displayName"
									value={displayName}
									onIonChange={_onChange}
								></IonInput>
							</IonItem>
							<IonItem>
								<IonLabel position="floating">Email</IonLabel>
								<IonInput
									name="email"
									value={email}
									onIonChange={_onChange}
								></IonInput>
							</IonItem>
						</>
					)}
					{role === "participant" && (
						<>
							<IonItem>
								<IonLabel position="floating">Participant Initials</IonLabel>
								<IonInput
									name="displayName"
									value={displayName}
									onIonChange={_onChange}
								></IonInput>
							</IonItem>
							<IonItem>
								<IonLabel position="floating">Username</IonLabel>
								<IonInput name="username" disabled value={username}></IonInput>
							</IonItem>
						</>
					)}
					<IonItem>
						<IonLabel position="floating">Password</IonLabel>
						<IonInput name="password" value={password}></IonInput>
						<IonButton onClick={_generatePassword} slot="end">
							Generate
						</IonButton>
					</IonItem>
					{role === "participant" && (
						<>
							<IonItem>
								<IonLabel position="floating">Study</IonLabel>
								<IonSelect
									compareWith={_compareStudy}
									value={study}
									name="study"
									onIonChange={_onSelect}
									okText="Okay"
									cancelText="Dismiss"
									placeholder="Select One"
								>
									<IonSelectOption value="sleep">Sleeping</IonSelectOption>
									<IonSelectOption value="eat">Eating</IonSelectOption>
									<IonSelectOption value="toilet">Toileting</IonSelectOption>
								</IonSelect>
							</IonItem>
							<IonItem>
								<IonLabel position="floating">Lead</IonLabel>
								<IonSelect
									compareWith={_compareLead}
									value={lead}
									name="lead"
									onIonChange={_onSelect}
									okText="Okay"
									cancelText="Dismiss"
									placeholder="Select One"
								>
									{admins &&
										admins.length > 0 &&
										admins.map((admin: any, idx: any) => (
											<IonSelectOption key={idx} value={admin.id}>
												{admin.displayName}
											</IonSelectOption>
										))}
								</IonSelect>
							</IonItem>
						</>
					)}
				</IonList>
			</IonContent>
			<IonFooter>
				<IonButton onClick={_addUser}>Add User</IonButton>
			</IonFooter>
		</IonModal>
	);
};
const mapStateToProps = (state: any) => ({
	usersData: state.user.users,
});

export default connect(mapStateToProps, {})(AddUserModal);
